import { render } from "./Personal.vue?vue&type=template&id=7b824147&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import "./Personal.vue?vue&type=style&index=0&id=7b824147&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b824147"]])

export default __exports__